import React from 'react';
import { SelectButton } from 'primereact/selectbutton';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';

interface ComponentProps {
  value: boolean;
  onChange: (value: boolean) => void;
  style?: any;
  disabled?: boolean;
}

const InputYesNoPlain: React.FC<ComponentProps> = ({ value, onChange, style, disabled = false }) => {
  const { tr } = useTranslationLgs();

  const model = [
    {
      name: tr('InputYesNoPlain.yes', 'Yes'),
      value: true,
    },
    {
      name: tr('InputYesNoPlain.no', 'No'),
      value: false,
    },
  ];
  return (
    <>
      <SelectButton
        options={model}
        optionValue={'value'}
        optionLabel={'name'}
        value={value}
        disabled={disabled}
        unselectable={false}
        onChange={e => {
          // PrimeReact SelectButton emits null when the selected option is clicked again (deselect).
          // This component's contract is boolean, so ignore null instead of propagating it (which led
          // to .toString() on null in consumers). unselectable={false} also prevents the deselect. (Sentry KV.)
          if (e.value === null || e.value === undefined) return;
          onChange(e.value);
        }}
      />
    </>
  );
};

export default InputYesNoPlain;
